<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="49" height="1" viewBox="0 0 49 1" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <line y1="0.5" x2="49" y2="0.5" stroke="white" />
</svg>
